export default __webpack_public_path__ + "static/media/footerlogo.367146e6.webp";